import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import {
  EMPLOYEE_GROUP_FORM,
  SUB_CONTRACTOR_FORM,
} from "features/planner/planner.constants";

import TextField from "app/components/form/TextField";
import { getCompaniesFromState } from "features/planner/planner.selectors";
import { required } from "utils/validation.util";

const SubContractorForm = ({ handleSubmit, companies }) => {
  return (
    <form onSubmit={handleSubmit} id={EMPLOYEE_GROUP_FORM.ID}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Field
            required
            autoFocus
            validate={[required]}
            name={SUB_CONTRACTOR_FORM.FIRST_NAME}
            label="First name"
            component={TextField}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            required
            validate={[required]}
            name={SUB_CONTRACTOR_FORM.LAST_NAME}
            label="Last name"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            select
            required
            validate={[required]}
            label="Company"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.COMPANY}
          >
            {companies.map(company => (
              <MenuItem value={company.get("id")} key={company.get("id")}>
                {company.get("name")}
              </MenuItem>
            ))}
          </Field>
        </Grid>
      </Grid>
    </form>
  );
};

export default compose(
  connect(state => ({
    companies: getCompaniesFromState(state),
  })),
  React.memo,
)(SubContractorForm);
